import { Badge } from './ui/badge';

const BASIS_META = {
  Demand: { label: 'Demand', cls: 'bg-amber-100 text-amber-800 border-amber-200' },
  Energy: { label: 'Energy', cls: 'bg-blue-100 text-blue-800 border-blue-200' },
  Reactive: { label: 'Reactive', cls: 'bg-purple-100 text-purple-800 border-purple-200' },
  PowerFactor: { label: 'Power Factor', cls: 'bg-teal-100 text-teal-800 border-teal-200' },
  Volume: { label: 'Volume', cls: 'bg-cyan-100 text-cyan-800 border-cyan-200' },
  Fixed: { label: 'Fixed', cls: 'bg-slate-100 text-slate-700 border-slate-200' },
};

export const BillingBasisBadge = ({ basis }) => {
  if (!basis) return null;
  const m = BASIS_META[basis] || BASIS_META.Fixed;
  return (
    <Badge
      variant="outline"
      className={`rounded-none text-[10px] px-1.5 py-0 font-medium ${m.cls}`}
      data-testid={`billing-basis-${basis.toLowerCase()}`}
    >
      {m.label}
    </Badge>
  );
};
